/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ExternalProfessionals/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import DataVaxiomProfessionalsRelationshipsList from 'DesignSystem/DataVaxiomProfessionalsRelationshipsList/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ExternalProfessionals({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/ExternalProfessionals"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let profilePatientIdValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: '_id',
})
  return (<React.Fragment
>
<div
  data-testid="ExternalProfessionals.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-225T4F': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-225T4F': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-225T4F': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="External professionals"
/>
</div>
<DataVaxiomProfessionalsRelationshipsList
  viewPath={`${viewPath}/DataVaxiomProfessionalsRelationshipsList`}
 data="profile_patient._id"
 patient_id={profilePatientIdValueData}
 dtype="otherProfessionalRelationship"
 past={false}
/>
{children}
</React.Fragment>)
}